var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-pc-page"},[_c('Header'),_c('Banner'),(_vm.template.meetingInfo.tab_1_p.display.value)?_c('Title',{attrs:{"info":{
      className: '',
      name: _vm.template.meetingInfo.tab_1_p.text.value,
      id: 'intro',
      enName: 'CONFERENCE INTRODUCTION'
    }}}):_vm._e(),(_vm.template.meetingInfo.tab_1_p.display.value)?_c('div',{staticClass:"m-area padd",domProps:{"innerHTML":_vm._s(_vm.webinarInfo.intro)}}):_vm._e(),(_vm.template.meetingInfo.tab_2_p.display.value)?_c('Title',{attrs:{"info":{
      className: 'gray',
      name: _vm.template.meetingInfo.tab_2_p.text.value,
      id: 'agenda',
      enName: 'CONFERENCE AGENDA'
    }}}):_vm._e(),(_vm.template.meetingInfo.tab_2_p.display.value)?_c('Schedule'):_vm._e(),(_vm.template.meetingInfo.tab_3_p.display.value)?_c('Title',{attrs:{"info":{
      className: '',
      name: _vm.template.meetingInfo.tab_3_p.text.value,
      id: 'guest',
      enName: 'CONFERENCE GUESTS'
    }}}):_vm._e(),_c('Card'),(_vm.template.meetingInfo.tab_3_p.display.value)?_c('Guests'):_vm._e(),(_vm.template.meetingInfo.tab_4_p.display.value)?_c('Title',{attrs:{"info":{
      className: '',
      name: _vm.template.meetingInfo.tab_4_p.text.value,
      id: 'custom'
    }}}):_vm._e(),(_vm.template.meetingInfo.tab_4_p.display.value)?_c('Expand'):_vm._e(),_c('span',{staticClass:"icontemp back-top hide",attrs:{"title":"回到顶部","id":"pc-back-top"},on:{"click":_vm.backToTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }